<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			{{ title }}
		</h3>
		<p>
			Nous avons conçu plusieurs outils pour vous aider à vous faire entendre.
		</p>

		<ul>
			<li>
				<a href="https://cdn.greenpeace.fr/site/uploads/2019/10/cantine-verte-outils-a-imprimer.zip" target="_blank" @click="link($event, 'tract')">Un tract</a> à déposer dans les écoles, les commerces, les lieux de vie de votre quartier et pourquoi pas votre mairie.
			</li>

			<li>
				<a href="https://cdn.greenpeace.fr/site/uploads/2019/10/cantine-verte-outils-a-imprimer.zip" target="_blank" @click="link($event, 'affiches')">Des affiches</a> que vous pouvez coller dans les lieux d’affichage publics et sur les panneaux d’affichage des écoles de votre commune.
			</li>
		</ul>

		<p>
			Une fois que vous avez collé vos affiches, n’hésitez pas à les diffuser sur Twitter en utilisant le hashtag #CantineVerte !
		</p>

		<p>
			<img src="https://cdn.greenpeace.fr/site/uploads/2019/11/Photo-tracts-affiches.jpg" class="w-100"/>
		</p>

		<div class="q-my-lg">
			<div class="button bg-rouge text-white btn-main" @click="open('https://cdn.greenpeace.fr/site/uploads/2019/10/cantine-verte-outils-a-imprimer.zip', 'zip')">
				<div>
					<span>Télécharger et imprimer</span>
					<q-icon name="arrow_forward"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ActionOut",
	props: {
		title: String,
	},
	methods: {
		link(e, label) {
			e.preventDefault()
			let href = e.target.href

			this.open(href, label)
		},
		open(href, label) {
			this.$trackEvent("click", "lien externe " + label)
			window.open(href, '_blank')
		}
	},
}
</script>